import { ReactElement } from 'react';

import AllocationBreadcrumbs from './AllocationBreadcrumbs';
import AddClientAllocationForm from './AddClientAllocationForm';
import { AddClientAllocationProvider } from './context/AddClientAllocationContext';

const AddClientAllocation = (): ReactElement => (
  <AddClientAllocationProvider>
    <AllocationBreadcrumbs />
    <AddClientAllocationForm />
  </AddClientAllocationProvider>
);

export default AddClientAllocation;
